import React, { useState, useEffect } from 'react';
//import './MemberOnboarding.css';
import { useParams } from "react-router-dom";
import { fetchServiceRecommendationHistory, generateReport } from '../../services/hih/Service';
import { CustomLoader, ModalBoxButton, decryptData } from '../../pages/utils/CommonLibrary';
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { toast } from "react-toastify";
import BackendDrivenDataTable from '../cn/components/common/BackendDrivenDataTable';
import CalendarDatePicker from '../componenents/CalendarDatePicker';
import { NotificationToast } from '../componenents/ContentCareNavigator/NotificationToast';

function RecommendationHistory() {

    const storedDates = localStorage.getItem('selectedDates') ? JSON.parse(decryptData(localStorage.getItem('selectedDates'))) : '';

    const [startDate, setStartDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[0]) : moment()
    );
    const [endDate, setEndDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[1]) : moment()
    );

    const { id } = useParams();
    const navigate = useNavigate();
    const [careUserName, setCareUserName] = useState('');
    const [transferFromCNTotalMembers, setTransferFromCNTotalMembers] = useState("");
    const [careData, setCareData] = useState([]);
    const [insightsData, setInsightsData] = useState([]);
    const [checked, setChecked] = useState([]);
    const [dropdownValues, setDropdownValues] = useState({});
    const [reasonSelect, setReasonSelect] = useState('All');
    const [typeSelect, setTypeSelect] = useState('All');
    const [reasonText, setReasonText] = useState('');
    const [selectError, setSelectError] = useState('');
    const [careError, setCareError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalClass, setModalClass] = useState('md');
    const [modalBody, setModalBody] = useState('');
    const [showModalButton, setShowModalButton] = useState(false);
    const [showSubmit, setShowSubmit] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [showHide, setShowHide] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [showBulkTransferModal, setShowBulkTransferModal] = useState(false);
    const [transferToCNList, setTransferToCNList] = useState("");
    const [allChecked, setAllChecked] = useState(false);

    //Changes related to backend driven data table 
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("createdTime");
    const [sortDirection, setSortDirection] = useState('desc');
    const [download, setDownload] = useState('N');
    const [conditionList, setConditionList] = useState([]);
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [cnList, setCNList] = useState([]);
    const [selectedCN, setSelectedCN] = useState(0);

    useEffect(() => {
        loadUserData();
    }, [startDate, endDate, page, perPage, sortColumn, sortDirection, filterText]);

    useEffect(() => {
        setAllChecked(false);
        setChecked([])
    }, [careData]);
    //=============================================


    const handleClose = () => {
        setShowModal(false);

        //setLoading(true);
        loadUserData();
        setReloadKey(prevKey => prevKey + 1);
    }

    const getNextWeekRange = () => {
        const end = new Date();
        const start = new Date();
        end.setDate(end.getDate() + 7);
        return [start, end];
    };

    const [errors, setErrors] = useState({
        conditions: '',
        carenavigator: ''
    });


    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        loadUserData();
    }, []);


    const loadUserData = async () => {
        try {
            setCareData([]);
            setLoading(true);
            fetchServiceRecommendationHistory(formatDate(startDate), formatDate(endDate), filterText, page, perPage, sortColumn, sortDirection)
                .then((response) => {
                    if (response.data.code == 200) {
                        setCareData(response.data.data.members);
                        setTotalRows(response.data.data.totalRows);
                        setInsightsData(response.data.data.insights[0]);
                    }
                }).finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            console.error('Error=', error);
        }
    }

    const genrateReport = async () => {
        try {
            setLoading(true); // show loader
            let sdate = formatDate(startDate);
            let edate = formatDate(endDate);
            let extraParams = { "searchStr": filterText }
            let response = await generateReport(sdate, edate, "aibuparecommendationreport", extraParams);
            if (response.data.code === 200) {
                if (response.data.data.status == 1) {
                    toast.success(response.data.data.msg, {
                        position: 'top-right'
                    })
                } else {
                    toast.error(response.data.data.msg, {
                        position: 'top-right'
                    })
                }
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);  // Will be called regardless of success or failure
        }
    }

    // function formatDate(dateString) {
    //     const date = new Date(dateString);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const day = String(date.getDate()).padStart(2, '0');
    //     return `${day}/${month}/${year}`;
    // }

    function formatDateYmd(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }



    const handleAllChange = (e) => {
        const { checked } = e.target;
        if (checked) {
            setChecked(careData.map(item => item.membershipNo));
            setAllChecked(true);
        } else {
            setChecked([]);
            setAllChecked(false);
        }
    };

    const handleCheckboxChange = (e, membershipNumber) => {
        const { checked } = e.target;

        setChecked(prevChecked =>
            checked
                ? [...prevChecked, membershipNumber]
                : prevChecked.filter(id => id !== membershipNumber)
        );

    };

    const handleDateChange = ({ start, end }) => {
        setStartDate(start);
        setEndDate(end);
    };

    const columns = [
        {
            name: 'Member ID',
            selector: row => row.membershipNo,
            sortable: true,
        },
        {
            name: 'Main Membership No',
            selector: row => row.mainMembershipNo,
            sortable: true,
        },
        {
            name: 'Member Name',
            selector: row => row.memberName,
            sortable: false,
        },
        {
            name: 'Mobile',
            selector: row => row.memberMobile,
            sortable: true,
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: true,
        },
        {
            name: 'Age',
            selector: row => row.age,
            sortable: true,
        },
        {
            name: 'VIP Code',
            selector: row => row.vipCode,
            sortable: true,
        },
        {
            name: 'Ambassador',
            selector: row => row.ambassadorInd,
            sortable: true,
        },
        {
            name: 'ID Card No',
            selector: row => row.idCardNo,
            sortable: true,
        },
        {
            name: 'Net Type',
            selector: row => row.netType,
            sortable: true,
        },
        {
            name: 'Contract No',
            selector: row => row.contractNo,
            sortable: true,
        },
        {
            name: 'Customer Name',
            selector: row => row.customerName,
            sortable: false,
        },
        {
            name: 'Contract Term Date',
            selector: row => row.contractTermDate,
            sortable: true,
        },
        {
            name: 'Service Type',
            selector: row => row.serviceType,
            sortable: true,
        },
        {
            name: 'Service Supply Date',
            selector: row => row.serviceSupplyTo,
            sortable: true,
        },
        {
            name: 'Service Code',
            selector: row => row.serviceCode,
            sortable: true,
        },
        {
            name: 'Service Description',
            selector: row => row.serviceDesc,
            sortable: false,
        },
        {
            name: 'Quantity',
            selector: row => row.servicelineItemQuantity,
            sortable: true,
        },
        {
            name: 'Dispensed Provider',
            selector: row => row.dispensedProvider,
            sortable: false,
        },
        {
            name: 'Dispensed Provider City',
            selector: row => row.dispensedProviderCity,
            sortable: false,
        },
        {
            name: 'Chronic Conditions',
            selector: row => row.chronicConditions,
            sortable: false,
        },
        {
            name: 'Generated Date',
            selector: row => row.generatedDate,
            sortable: true,
        },
        {
            name: 'Member Type',
            selector: row => row.memberType,
            sortable: true,
        },
        {
            name: 'Current Status',
            selector: row => row.currentStatus,
            sortable: true,
        },
        {
            name: 'Dismissal Reason',
            selector: row => row.dismissalReason,
            sortable: false,
        },
        {
            name: 'Dismissal Comments',
            selector: row => row.dismissalComments,
            sortable: false,
        },
        {
            name: 'Action Date',
            selector: row => row.actionTime,
            sortable: true,
        },
        {
            name: 'Action By',
            selector: row => row.actionByName,
            sortable: true,
        },
        {
            name: 'Action By Role',
            selector: row => row.actionBy,
            sortable: true,
        },
        {
            name: 'Created Date',
            selector: row => row.createdTime,
            sortable: true,
        }
    ];

    const handleConditions = (selectedOptions) => {
        //const selectedValues = selectedOptions.map((option) => option.value);
        setSelectedConditions(selectedOptions);
    };
    return (
        <>
            <NotificationToast />
            <section className='ReportsPrograms'>
                <div className="container-fluid px-0 mb-3 ">
                    <div className="row align-items-center pb-3 sticky-top-bar">
                        <div className="col-md-9">
                            <h1 className="main-title">Service Recommendation History</h1>
                        </div>
                        <div className="col-md-3">
                            <CalendarDatePicker startDate={startDate} endDate={endDate} onDateChange={handleDateChange} />
                        </div>
                    </div>

                    <div className='reports-programs mb-3'>
                        <div className="row align-items-center">
                            <div className="col-md-auto">
                                <img src="https://storage.googleapis.com/ksabupatest/2025/04/04/lj78f/rjm3b2w4kj.jpg" alt="Invited Members icon" style={{ height: "140px" }} className="img-fluid mb-0" />
                            </div>
                            <div className="col-md">
                                <p className="mb-0">The Service Recommendation History module provides a detailed insights of all past service suggestions made for members, enabling easy tracking, review, and analysis of recommended services over time.</p>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row align-items-center pb-3 sticky-top-bar">
                    <div className="col-md" style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                    </div>
                </div> */}
                    <div className="container-fluid">
                        <div className="row align-items-center pb-3">
                            <div className='comntent-MemberTransfer mb-3 p-3'>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-group" style={{ width: "100%" }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        value={filterText}
                                                        onChange={e => {
                                                            setPage(1);
                                                            setFilterText(e.target.value);
                                                        }}
                                                        className="form-control input-field-ui ps-5"
                                                    />
                                                    <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/wjm48/fh6lw97sch.png" className="input-icon-seacrh" alt="" />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-auto px-1'>
                                        <button onClick={() => genrateReport()} className="btn btn-primary btn-primary clear-search-btn"><i className="bi bi-download"></i> Export</button>
                                    </div>

                                    <div className='content-ProgramPerformance mb-3 p-2'>
                                        <div className='row text-center px-2'>
                                            <div className="col-3 px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.recordsCount}</h1>
                                                                <h5 className="card-text1">
                                                                    No of Records
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-3 px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.uniqueMembershipCount}</h1>
                                                                <h5 className="card-text1">
                                                                    Unique Members
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-3 px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.vipCount}</h1>
                                                                <h5 className="card-text1">
                                                                    VIP Recommendations Count
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-3 px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.ambassadorCount}</h1>
                                                                <h5 className="card-text1">
                                                                    Ambassador Recommendations Count
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row text-center px-2 mt-2'>

                                            <div className="col px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.onboardedMembers}</h1>
                                                                <h5 className="card-text1">
                                                                    Onboarded Members
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.notOnboardedMembers}</h1>
                                                                <h5 className="card-text1">
                                                                    Not Onboarded Members
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.labConverted} / {insightsData.labOutreached}</h1>
                                                                <h5 className="card-text1">
                                                                    Converted for lab / Outreached for lab
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col px-1">
                                                <div className="card bg-grey" style={{ borderRadius: '14px', border: 'none', height: '100%' }}>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col">
                                                                <h1 className="card-title1" style={{ fontSize: "16px", fontWeight: "500" }}>{insightsData.refillConverted} / {insightsData.refillOutreached}</h1>
                                                                <h5 className="card-text1">
                                                                    Converted for refill / Outreached for refill
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-12">
                                        <div className="table-responsive MemberTransferTable">
                                            <div className="text-danger">{selectError}</div>
                                            <div className="text-danger">{careError}</div>
                                            {

                                                <div>
                                                    {
                                                        loading ? <CustomLoader /> :
                                                            <BackendDrivenDataTable
                                                                data={careData}
                                                                loading={loading}
                                                                totalRows={totalRows}
                                                                page={page}
                                                                perPage={perPage}
                                                                sortColumn={sortColumn}
                                                                sortDirection={sortDirection}
                                                                columns={columns}
                                                                fetchTableData={loadUserData}
                                                                setPage={setPage}
                                                                setSortColumn={setSortColumn}
                                                                setSortDirection={setSortDirection}
                                                                setPerPage={setPerPage}
                                                            />
                                                    }
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default RecommendationHistory